import axios from 'axios'
import {ResponseObject} from '../../../../../models'
import {RoomModel} from '../models'
const BASEURL = process.env.REACT_APP_DEV_API_HOTELERIA_URL

export async function getRoomByIdService(id: string | undefined) {
  return await axios.get<ResponseObject<RoomModel>>(`${BASEURL}/room/getRoomById`, {
    params: {
      Id: id,
    },
  })
}
